declare global {
  interface Window {
    pendo: {
      initialize: (options: { visitor: { id: string }; account: { id: string } }) => void;
      track: (eventName: string, metadata?: unknown) => void;
      stopSendingEvents: () => void;
      isSendingEvents: () => boolean;
      clearSession: () => void;
    };
  }
}

export const PENDO_API_KEY = "ad69ed72-8f8c-4473-958d-b81d5552c2dc";

export function injectPendoScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.getElementById("pendo-script")) {
      resolve();
      return;
    }

    console.log("Injecting Pendo script...");
    const inlineScript = document.createElement("script");
    inlineScript.id = "pendo-inline-script";
    inlineScript.type = "text/javascript";
    inlineScript.text = `
      (function(p,e,n,d,o){
        var v,w,x,y,z;
        o=p[d]=p[d]||{};
        o._q=[];
        v=['initialize','identify','updateOptions','pageLoad','track'];
        for(w=0,x=v.length;w<x;++w)(function(m){
          o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};
        })(v[w]);
      })(window,document,'script','pendo');
    `;
    document.head.appendChild(inlineScript);

    const script = document.createElement("script");
    script.id = "pendo-script";
    script.async = true;
    script.src = `https://cdn.pendo.io/agent/static/${PENDO_API_KEY}/pendo.js`;
    script.onload = () => {
      console.log("Pendo initialized successfully.");
      resolve();
    };
    script.onerror = () => reject(new Error("Failed to load Pendo script"));
    document.head.appendChild(script);
  });
}

export function initializePendo(visitorId: string, accountId: string): void {
  console.log("Initializing Pendo with visitorId: " + visitorId + ", accountId: " + accountId);
  window.pendo.initialize({
    visitor: { id: visitorId },
    account: { id: accountId },
  });
}

export function disablePendo(): void {
  if (window.pendo?.isSendingEvents?.()) {
    console.log("Stopping Pendo...");
  }

  window.pendo?.stopSendingEvents();
  window.pendo?.clearSession();
}

export async function hashVisitorId(username: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(username);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function trackPendoEvent(eventName: string, metadata?: unknown): void {
  if (window.pendo?.track && window.pendo?.isSendingEvents) {
    if (window.pendo?.isSendingEvents()) {
      console.debug("Tracking Pendo event:", eventName, metadata);
      window.pendo.track(eventName, metadata);
    } else {
      console.debug("Pendo event tracking is disabled");
    }
  } else {
    console.warn("Cannot track Pendo event: SDK not ready", eventName);
  }
}
